"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('activity');
var RecentActivityHeaderComponent = function RecentActivityHeaderComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("activity"),
    t = _useTranslation.t;
  var headerText = props.headerText,
    children = props.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('header-bar')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('header-text')
  }, t(headerText)), children);
};
RecentActivityHeaderComponent.defaultProps = {
  headerText: 'Recent Activity'
};
var _default = exports["default"] = RecentActivityHeaderComponent;